import React from 'react';
import { injectIntl } from 'react-intl';

import ActionLink from '../components/builder/ActionLink';
import { i18nIntl, isNotEmpty } from '../lib/ep';
import ButtonCollection from '../components/builder/ButtonCollection';
import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText';
import { BrowserRouter as Router, Route ,useHistory,useParams} from 'react-router-dom';
import ClaimPromoFull from './ClaimPromoFull';

const SinglePrize = injectIntl((props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const history = useHistory()
	const prize = props?.prize?.Prize ?? false;
	if(prize === false) return null;

	const prize_type = props.prize_types[prize.prize_type].PrizeType ?? {};
	const prize_title = (isNotEmpty(prize_type, 'title')) ? prize_type.title : i18n("Unknown prize");
	const current = EPDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
	const has_expired = prize_type?.claim_expiration_date < current;
	const can_claim = (props.claim?.PromoClaim?.status ?? '0') == '0' && !has_expired;

	const is_claimed =  (props.claim?.PromoClaim?.status ?? '0') != '0';

	if(props?.is_guest ?? false) {
		return (
			<li class="prize_item">
				<span style={{ fontSize:'1.2em' }}>
					<strong class="gui_force_bold">{prize_title}</strong>
				</span>
			</li>
		)
	}

	return (
		<li class="prize_item">
			<span style={{ fontSize:'1.2em' }}>
				<strong class="gui_force_bold">{prize_title}</strong>

				{/* {(isNotEmpty(promo_code, 'code')) && (
					<span> ({promo_code.code})</span>
				)} */}

				{/* {(isNotEmpty(prize_type, 'unique_code')) && (
					<span> ({prize_type.unique_code})</span>
				)} */}
			</span>

			{has_expired && !is_claimed && (
				<div>
					This prize can no longer be claimed
				</div>
			)}

			<ButtonCollection _class={{other:"gui_padded_children_low"}}>
				{can_claim && (
				<ActionLink
					onClick={() => history.push(prize.id)}
					_class={{ other:'hb_mainFontWeightBold gui_capitalize_text' }}
				>Claim
				</ActionLink>
				)}

				{is_claimed && (
				<ActionLink
					onClick={() => history.push(prize.id)}
					_class={{ other:'hb_mainFontWeightBold gui_capitalize_text' }}
				>Already claimed on {props.claim?.PromoClaim.claim_date}
				</ActionLink>
				)}
			</ButtonCollection>
		</li>
	)
});

const Wrapper = (props) => {
	const is_standalone = props?.is_standalone ?? false;
	const total_prizes = props?.total_prizes ?? 0;

	const winner_label = (total_prizes == 0) ? "You haven't won any prize yet." : ((total_prizes > 1) ? "You've won {prizes} prizes" : "You've won {prizes} prize");

	if(is_standalone) {
		return (
			<div class="prizes_won">
				<LeveledHTMLText>
					<h1>{props.intl.formatMessage({ id:winner_label }, { prizes:total_prizes })}</h1>
				</LeveledHTMLText>

				{props.children}
			</div>
		)
	}

	return (
		<div class="prizes_won">
			{props.children}
		</div>
	)
};

const ClaimPrize = (props) => {
	const {prize_id} = useParams();
	const history = useHistory();
	const prize = props.user_prizes.find(p=>(p.Prize.id==prize_id));
	const prize_type =  props.prizes.find(p=>(p.PrizeType.id == prize.Prize.prize_type))

	return (
		<ClaimPromoFull 
			prize_id={prize_id}
			prize_type={prize_type.PrizeType}
			claim={props?.claims[prize_id]}
			back={()=>{history.push('/')}}
			{...props}
		/>
	)
}

const PrizesList = (props) => {
	return (
		<ul class="won_prizes_textual_list">
			{props.prizes.map((prize, k) => {
				return (
					<SinglePrize
						key={`prize_${k}`}
						prize={prize}
						prize_types={props.prize_types}
						claim={props.claims[prize.Prize.id]}
					/>
				)
			})}
		</ul>
	)
}

const UserClaim = (props) => {
	const prizes = props?.prizes ?? [];
	const total_prizes = prizes.length;

	if(total_prizes == 0) {
		return (
			<Wrapper
				is_standalone={props.is_standalone}
				intl={props.intl}
			/>
		);
	}
	const section_main_path = `/users/claim/${props.promotion.Promotion.id}`;
	return (
		<Router basename={section_main_path} >
			<Route exact={true} path={`/`}>
				<Wrapper
					is_standalone={props.is_standalone}
					total_prizes={total_prizes}
					intl={props.intl}
				>
					<PrizesList
						prizes={props.prizes}
						prize_types={props.prize_types}
						claims={props.claims}
					/>
				</Wrapper>
			</Route>


			<Route exact={true} path={`/:prize_id`}>
				<ClaimPrize
					promotion={props.promotion}
					prizes={Object.values(props.prize_types)}
					user_prizes={prizes}
					claims={props.claims}
					user={props.user}
				/>
			</Route>
		</Router>
	)
};

export default injectIntl(UserClaim);